// extracted by mini-css-extract-plugin
export var divider = "_yb-0";